import { VerticalLayout } from "../components/layout";
import { SkeletonCircle, SkeletonDiv } from "./skeletonloaders";

export function User({ name, email, avatar, goProfile }) {
  if (name === "-") {
    return (
      <div
      onClick={goProfile}
      className="horizontal user-comp profile-item"
      style={{ width: "unset", textAlign: "left", "padding": "0.25rem 0.5rem" }}
    >
      <div>
        <SkeletonCircle style={{"height": "2rem", "width": "2rem", marginRight: "0.5rem"}} />
      </div>
      <VerticalLayout>
        <div className="profile-text">
          <SkeletonDiv style={{"height": "1rem", "width": "7.5rem", "borderRadius": "100vh"}}/>
          <SkeletonDiv style={{"height": "0.75rem", "width": "10rem", "marginTop": "0.25rem", "borderRadius": "100vh"}}/>
        </div>
      </VerticalLayout>
    </div>
    )
  }

  return (
    <div
      onClick={goProfile}
      className="horizontal user-comp profile-item"
      style={{ width: "unset", textAlign: "left", "padding": "0.25rem 0.5rem" }}
    >
      <div className="standard-margin">
        <img
          className="small-img rounded-img"
          src={avatar}
          alt={"avatar"}
        />
      </div>
      <VerticalLayout onClick={goProfile} style={{"justifyContent":"center"}}>
        <div className="profile-text">
          <p className="topbar-profile-name">{name}</p>
          <p className="topbar-profile-email">{email}</p>
        </div>
      </VerticalLayout>
    </div>
  );
}
